module.exports = __webpack_public_path__ + "static/media/icon.adcff230.svg";